export default [{ //集成托管服务申请列表
        path: '/integrateManagement',
        name: 'integrateManagement',
        meta: { title: '集成托管服务申请列表' },
        component: () =>
            import ('../../views/integrateManagement/index.vue')
    },
    { //集成托管服务公司详情
        path: '/integrateManagement/companyDetail/:id',
        name: 'integrateManagementCompany',
        meta: { title: '集成托管服务公司详情' },
        component: () =>
            import ('../../views/integrateManagement/companyDetail.vue')
    },
    { //集成托管服务申请详情
        path: '/integrateManagement/detail/:id',
        name: 'integrateManagementDetail',
        meta: { title: '集成托管服务申请详情' },
        component: () =>
            import ('../../views/integrateManagement/detail.vue')
    }
]